export const theme = Object.freeze ( {
    colors: {
      black: '#000',
      white: '#fff',
      primaryText: '#010101',
      secondaryText: '#fafafa; ',
      backgroundBody: '#fcfefe',
      secondBackground: '#eaf6f6',
      accentColor: '#66bfbf',
      buttonColor: '#f76b8a ',

    },
    space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
    fonts: {
      body: 'system-ui, sans-serif',
      heading: 'system-ui, sans-serif',
      monospace: 'Menlo, monospace',
    },
    fontSizes: {
      xs: '12px',
      s: '14px',
      m: '16px',
      l: '24px',
      xl: '32px',
    },
    fontWeights: {
      normal: 400,
      bold: 700,
    },
    lineHeights: {
      body: 1.5,
      heading: 1.125,
    },
    borders: {
      none: 'none',
      normal: '2px solid #757575',
    },
    radii: {
      none: '0',
      normal: '4px',
      round: '50%',
    },
  } );